export const gpsSinglePointTranslations = {
  en: {
    errorHeader: 'GPS Coordinates Error',
    errorMessage: 'There was a problem retrieving your GPS coordinates. Please enable location services in your phone settings.',
    okButton: 'Ok'
  },
  it: {
    errorHeader: 'Errore di recupero coordinate GPS',
    errorMessage: 'C\'è stato un problema nel recupero delle tue coordinate GPS. Per favore abilita il navigatore nelle impostazioni del telefono.',
    okButton: 'Ok'
  }
}; 